import { render, staticRenderFns } from "./masteries.small.vue?vue&type=template&id=030bc90b&scoped=true&"
import script from "./masteries.small.vue?vue&type=script&lang=js&"
export * from "./masteries.small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030bc90b",
  null
  
)

export default component.exports